import { rootStore } from 'cv-react-core';

const coreStyles = {
    container: {
        backgroundColor: 'transparent',
    },
};

const getStyles = (contextStyles) => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    return {
        page: {
            icon: theme.appIcon,
            name: theme.appName,
        },
        container: {
            ...coreStyles.container,
            backgroundColor: theme.pageBackgroundColor,
            ...contextStyles.container,
        },
    };
};

export default getStyles;
